/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable no-fallthrough */
/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-useless-return */
/* eslint-disable import/prefer-default-export */

import { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// import { debounce } from 'lodash';
import {
  TAB_ACTION,
  workNotesFilterOptions,
  deviceActivityFilterOptions,
  recordingsFilterOptions,
} from '../../constants';
import { defaultQueryFilterValue, defaultDataValue } from '../../helper';
import { useDebounce } from '../../../../hooks/useDebounce';
import utils from '../../../../lib/utils';
import { getFilterNotes, selectedNotesTab, notesTabFilters } from '../../../../actions/EpikBoxes';
import { useSelector } from 'react-redux';

/* Handle Edit Note paginatio => if user changes note from page 2 then you should be sending the page + 2 */
export const useNotes = (onDeleteNote, boxDetails, onDeleteNoteRecording) => {
  const DEBOUNCED_DELAY = useRef(100);

  const [filterOptionsState, setFilterOptionsState] = useState(workNotesFilterOptions);
  const { 0: EMAIL } = filterOptionsState;

  const [selectedTab, setSelectedTab] = useState(TAB_ACTION.WORK_NOTES);
  const [selectedOption, setSelectedOption] = useState(EMAIL);
  const [shouldFilter, setShouldFilter] = useState(true);
  const [modal, setModal] = useState(false);
  const [noteMode, setNoteMode] = useState('ADD');
  const [queryFilter, setQueryFilter] = useState(defaultQueryFilterValue);
  const [data, setData] = useState(defaultDataValue);

  const [boxNotes, setBoxNotes] = useState({});
  const [sort, setSort] = useState({ name: 'createdAt', order: 'desc' });
  const currentSelectedBox = useSelector(state => state.AppState.boxDetails.box)
  const [notesLoading, setNotesLoading] = useState(true)
  
  const dispatch = useDispatch();

  const handleSortNotes = useCallback(filter => {
    const updateSort = sort;

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    setSort(updateSort);
    updateFetchQuery();
  });
  const getFilterNotes_ = (token, id, queryFilter_, pagination, flag = true, sortOptions = sort) => {
    if (currentSelectedBox.boxId) { // incase of box not loaded accessed from table row notes icon
      id = currentSelectedBox?.boxId
    }
    return dispatch(getFilterNotes(token, id, queryFilter_, pagination, flag, sortOptions));
  }

  const updateFetchQuery = useCallback(async () => {
    const token = utils.getAuthToken();
    const boxId = boxDetails._id;
    const pagination = { page: 1, limit: 10 };
    const queryFilter_ = getQueryFilterTypeBasedOnTab(selectedTab);
    const sortOptions = sort;
    const response = await getFilterNotes_(
      token,
      boxId,
      queryFilter_,
      pagination,
      true,
      sortOptions,
    );
    setBoxNotes(() => response);
  }, [selectedTab, boxDetails, sort]);

  const getQueryFilterTypeBasedOnTab = useCallback(tab => {
    switch (tab) {
      case TAB_ACTION.WORK_NOTES:
        return { type: 'allUsers' };
      case TAB_ACTION.DEVICE_ACTIVITY:
        return { type: 'system' };
      case TAB_ACTION.RECORDINGS:
        return { type: 'recording' };
      default:
        break;
    }
  }, []);

  const fetchNoteAccordingToTab = useCallback(
    async tab => {
      const pagination = { page: 1, limit: 10 };
      const boxId = boxDetails._id;
      const token = utils.getAuthToken();
      const queryFilter_ = getQueryFilterTypeBasedOnTab(tab);
      const response = await getFilterNotes_(token, boxId, queryFilter_, pagination, true);
      setBoxNotes(response);
      setNotesLoading(false)
    },
    [boxDetails],
  );

  const mountedRef = useRef(false);

  useEffect(() => {
    if (!mountedRef.current) {
      fetchNoteAccordingToTab(selectedTab);
      changeFilterOptionsWithoutTypeinTab(selectedTab);
      mountedRef.current = true;
    }
  }, []);

  const { applyDebounce } = useDebounce(DEBOUNCED_DELAY.current);

  const setQueryFilterAccordingToCurrentTab = useCallback((val, reset = true) => {
    const defaultStates = { to: '', from: '', email: '' };
    switch (val) {
      case TAB_ACTION.WORK_NOTES: {
        setQueryFilter(prev => ({
          ...(reset ? defaultStates : prev),
          type: 'allUsers',
        }));
        break;
      }
      case TAB_ACTION.DEVICE_ACTIVITY: {
        setQueryFilter(prev => ({
          ...(reset ? defaultStates : prev),
          type: 'system',
        }));
        break;
      }
      case TAB_ACTION.RECORDINGS: {
        setQueryFilter(prev => ({
          ...(reset ? defaultStates : prev),
          type: 'recording',
        }));
        break;
      }
      default:
        break;
    }
  }, []);

  const setFilterOptionsAccordingToCurrentTab = useCallback(val => {
    switch (val) {
      case TAB_ACTION.WORK_NOTES: {
        setFilterOptionsState(workNotesFilterOptions);
        setSelectedOption(workNotesFilterOptions[0]);
        break;
      }
      case TAB_ACTION.DEVICE_ACTIVITY: {
        setFilterOptionsState(deviceActivityFilterOptions);
        setSelectedOption(deviceActivityFilterOptions[0]);
        break;
      }
      case TAB_ACTION.RECORDINGS: {
        setFilterOptionsState(recordingsFilterOptions);
        setSelectedOption(recordingsFilterOptions[0]);
        break;
      }
      default:
        break;
    }
  }, []);

  const handleTabChange = useCallback(
    val => () => {
      if (val.includes(selectedTab)) return;
      setNotesLoading(true)
      dispatch(selectedNotesTab(val));
      setSelectedTab(val);
      setQueryFilterAccordingToCurrentTab(val);
      setFilterOptionsAccordingToCurrentTab(val);
      fetchNoteAccordingToTab(val);
    },
    [selectedTab],
  );

  const returnTypeBasedOnTab = useCallback(tab => {
    switch (tab) {
      case TAB_ACTION.WORK_NOTES:
        return 'allUsers';
      case TAB_ACTION.DEVICE_ACTIVITY:
        return 'system';
      case TAB_ACTION.RECORDINGS:
        return 'recording';
      default:
        break;
    }
  }, []);

  const changeFilterOptionsWithoutTypeinTab = useCallback(tab => {
    const defaultStates = { to: '', from: '', email: '' };
    const type = returnTypeBasedOnTab(tab);
    setQueryFilter(() => ({ ...defaultStates, type }));
  }, []);

  const handleFilterOptionsDropDownChange = useCallback(
    e => {
      const { value } = e.currentTarget;
      setSelectedOption(value);
      /* setting state type = none when type is switched */
      if (value === 'Type') {
        const defaultStates = { to: '', from: '', email: '' };
        setQueryFilter(() => ({ ...defaultStates, ['type']: 'user' }));
        return;
      }
      changeFilterOptionsWithoutTypeinTab(selectedTab);
    },
    [selectedTab],
  );

  const showNewNoteButton = useMemo(() => !!selectedTab.includes(TAB_ACTION.WORK_NOTES), [
    selectedTab,
  ]);

  const handleStateChange = useCallback((name, value) => {
    let value_ = value;
    if (name === 'type') {
      value_ = value === 'none' ? 'user' : 'userWithAttachment';
    }
    setQueryFilter(prev => ({ ...prev, [name]: value_ }));
  }, []);

  const debouncedHandleChange = useCallback(e => {
    const { value, name } = e?.currentTarget;
    applyDebounce(() => handleStateChange(name, value));
  }, []);

  const handleModal = useCallback((val = true, mode = 'ADD') => {
    setModal(val);
    setNoteMode(mode);
    if (mode === 'ADD') {
      setData({ note: '', uploadedFile: {}, selectedBox: {} });
    }
  }, []);

  const handleEditNote = useCallback(val => {
    if (!val) return;
    setData({
      selectedBox: val,
      note: val?.note,
      uploadedFile: { ...(val?.attachment?.name ? { name: val?.attachment?.name } : {}) },
    });
    handleModal(true, 'EDIT');
  }, []);

  const handleDeleteNote = useCallback(
    async e => {
      await onDeleteNote(e._id);
      await updateFetchQuery();
    },
    [selectedTab, boxDetails],
  );

  const onDeleteRecording = useCallback(
    async note => {
      await onDeleteNoteRecording(note._id);
      await updateFetchQuery();
    },
    [selectedTab, boxDetails],
  );

  const onPageChange = useCallback(
    async e => {
      setNotesLoading(true)
      const pagination = { page: e, limit: 10 };
      const { email, type, to, from } = queryFilter;
      const token = utils.getAuthToken();
      const boxId = boxDetails._id;
      let queryFilter_ = {};
      if (selectedOption === 'Email') {
        queryFilter_ = { email, type };
      } else if (selectedOption === 'Type') {
        queryFilter_ = { type };
      } else {
        queryFilter_ = { from, to, type };
      }
      const response = await getFilterNotes_(token, boxId, queryFilter_, pagination, false);
      setBoxNotes(response);
      setNotesLoading(false)
    },
    [boxDetails, queryFilter],
  );

  const onSavePress = useCallback(
    async e => {
      const pagination = { page: 1, limit: 10 };
      const { email, type, to, from } = queryFilter;
      const token = utils.getAuthToken();
      const boxId = boxDetails._id;
      setShouldFilter(true);
      let queryFilter_ = {};
      if (e === 'Email') {
        queryFilter_ = { email, type };
      } else if (e === 'Type') {
        queryFilter_ = { type };
      } else {
        queryFilter_ = { to, from, type };
      }
      dispatch(notesTabFilters(queryFilter_));
      const response = await getFilterNotes_(token, boxId, queryFilter_, pagination, false);
      setBoxNotes(response);
    },
    [queryFilter, boxDetails],
  );

  const onKeyPress = useCallback(
    async e => {
      const { key } = e;
      const { email, from, to } = queryFilter;
      if (key === 'Enter') {
        if (email) {
          await onSavePress('email');
        } else if (from && to) {
          await onSavePress('date');
        } else {
          const defaultStates = { email: '', from: '', to: '' };
          setQueryFilter(prev => ({ ...prev, ...defaultStates }));
        }
      }
    },
    [queryFilter],
  );

  return {
    onKeyPress,
    onSavePress,
    noteMode,
    shouldFilter,
    data,
    onDeleteRecording,
    setData,
    handleEditNote,
    handleDeleteNote,
    onPageChange,
    modal,
    handleModal,
    selectedTab,
    handleTabChange,
    filterDropDownOptions: filterOptionsState,
    selectedOption,
    handleFilterOptionsDropDownChange,
    showNewNoteButton,
    debouncedHandleChange,
    updateFetchQuery,
    boxNotes,
    sort,
    handleSortNotes,
    notesLoading
  };
};
